type LoadRouteModule = () => Promise<unknown>;

export type LazyRoute = {
  lazy?: LoadRouteModule;
  children?: LazyRoute[];
};

const collectLazyModules = (routes: LazyRoute[]): LoadRouteModule[] =>
  routes.flatMap(({ lazy, children = [] }) => [
    ...(lazy ? [lazy] : []),
    ...collectLazyModules(children),
  ]);

// A failed preload is not an error: navigating to that route loads it again and reports through its errorElement.
export const preloadLazyRoutes = async (routes: LazyRoute[]) => {
  await Promise.allSettled(collectLazyModules(routes).map((load) => load()));
};

export const whenIdle = (callback: () => void) => {
  if (typeof window.requestIdleCallback !== 'function') {
    window.setTimeout(callback);
    return;
  }

  window.requestIdleCallback(callback);
};
